import { FunctionComponent as F } from "react";
import MaUTable from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import CostBreakdownRowGroup, { RowGroup } from "./CostBreakdownRowGroup";



interface IProps
{
  rowGroups: RowGroup[];
  saving?: number
}

const CostBreakdownTable: F<IProps> = (props: IProps) =>
{
  const headings = [
    { Header: 'Item', accessor: 'item' },
    { Header: 'Value', accessor: 'value' },
    { Header: '', accessor: 'toggle', width: 1 } ];

  return (
    <MaUTable size='small' style={{ width: 600 }}>
      <TableHead>
        <TableRow>
          <TableCell key={0}>
            <b>{headings[0].Header}</b>
          </TableCell>
          <TableCell key={1} style={{ textAlign: 'right' }}>
            <b>{headings[1].Header}</b>
          </TableCell>
          <TableCell key={2} style={{ width: 1 }}/>
        </TableRow>
      </TableHead>
      <TableBody>
        {props.rowGroups.filter(row => row.show || row.show === undefined).map((rowGroup, i) =>
          <CostBreakdownRowGroup key={i} rowGroup={rowGroup} rowGroupIndex={i}/>)}
      </TableBody>
    </MaUTable>);
};

export default CostBreakdownTable;
